import { gql } from "@apollo/client"

export const USER_EDIT = gql`
  mutation UserEdit($UserEditInput: UserEditInput!) {
    UserEdit(input: $UserEditInput) {
      status {
        success
        name
        detail
      }
      person {
        id
        avatar
        fullName
        urlAvatar
        urlEdit
        code
      }
    }
  }
`
